export interface DataEntity_Detail_02_Interface {
  id: number,
  main_id: number,
  nominal: number,
  mesured: Array<string>,
  yb: string,
  y: string,

  PA: string,
  PW: string,
  Temperature_Device: string,

  uncertainty: string,

  error: number,

  average: number,
  sd: number,
  cv: number,

  mpe_min: number,
  mpe_max: number,
  mpe_goal: number,
  mpe_sys: number,
  mpe_rnd: number,

  reference_Value: number,
  zFactor: string,
  converage: string,
  value: string,
  correction: number,

  mesured_visible: boolean,


  range_min:string,
  range_max:string,
  scale:string,

  ////Mohit


  temperature_Water_before:string,
  temperature_Water_after:string,

  temperature_Air_before:string,
  temperature_Air_after:string,

  humidity_Air_before:string,
  humidity_Air_after:string,

  pressure_before:string,
  pressure_after:string,

  reference_Temperature: number,

  before:boolean,
}

export function Empty_DataEntity_Detail_02_Interface(): DataEntity_Detail_02_Interface {
  return {
    id: 0,
    main_id: 0,
    error: 0,
    nominal: 0,
    mesured: [],
    yb: '8.0',
    y: '0.00001',

    PA: '',
    Temperature_Device: '',
    PW: '',

    uncertainty: '',

    average: 0,
    sd: 0,
    cv: 0,

    mpe_min: 0,
    mpe_max: 0,
    mpe_goal: 0,
    mpe_sys: 100000,
    mpe_rnd: 100000,

    reference_Value: 0,
    zFactor: '',
    converage: '',
    value: '',
    correction: 0,

    mesured_visible: false,

    range_min:'',
    range_max:'',
    scale:'',

    ////Mohit


    temperature_Water_before:'',
    temperature_Water_after:'',

    temperature_Air_before:'',
    temperature_Air_after:'',

    humidity_Air_before:'',
    humidity_Air_after:'',

    pressure_before:'',
    pressure_after:'',

    reference_Temperature: 20,

    before:false
  }
}
